import { sourceAnalysisLogic } from './source_analysis.logic';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import type { ActivityPlugin } from '../../core/types/activity.types';
import {
  SourceAnalysisHostView,
  SourceAnalysisProjectorView,
  SourceAnalysisStudentView,
} from '../humanities/SourceAnalysisBlock';

export const sourceAnalysisPlugin: ActivityPlugin<'source_analysis'> = {
  ...sourceAnalysisLogic,
  displayName: GAME_MODE_CATALOG.source_analysis.displayName,
  icon: GAME_MODE_CATALOG.source_analysis.icon,
  HostView: SourceAnalysisHostView,
  StudentView: SourceAnalysisStudentView,
  ProjectorView: SourceAnalysisProjectorView,
};

export { demoSourceAnalysisPayload } from './source_analysis.logic';
